import { StepContext } from '@/contexts/StepContext';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Grid, Paper, Typography } from '@mui/material';
import { Text, Select, IFormLookupFilterProps } from '@ngt/forms';
import { Condition, ConditionMode, useFormActions, useScopedField } from '@ngt/forms-core';
import { FC, useMemo } from 'react';
import * as Dtos from '../../api/dtos';
import RegistrationField from '../RegistrationField';
import RegistrationStepFour from './steps/RegistrationStepFour';
import RegistrationStepOne from './steps/RegistrationStepOne';
import RegistrationStepThree from './steps/RegistrationStepThree';
import RegistrationStepTwo from './steps/RegistrationStepTwo';
import useSponsors from '@/hooks/useSponsors';

const studentOrRegistrarOrTrialCoordinatorSelectedCondition = ({value}: any) => value?.student === true || value?.trialCoordinator === true || value?.registrar === true;

export const SponsorLevel: FC = () => {
    const subscription = {
        value: true
    };

    const {
        state: {
            value: sponsorId
        }
    } = useScopedField<boolean>('sponsorId', subscription);

    const {
        context: {
            setValue: setFreeSponsorRegistration
        }
    } = useScopedField<boolean>('freeSponsorRegistration', subscription);

    const { sponsors } = useSponsors();

    const sponsorLevel = () => {
        let freeRego = sponsors?.find(s => s.id == sponsorId)?.freeRegistrations;
        let regoUsed = sponsors?.find(s => s.id == sponsorId)?.registrationsUsed;
        if (freeRego)
        {
            if (regoUsed)
            {
                setFreeSponsorRegistration(regoUsed < freeRego);
                return (regoUsed < freeRego); // main check
            }
            else if (freeRego > 0) // free rego > 0 and rego used null
            {
                setFreeSponsorRegistration(true);
                return true; 
            }
        }
        setFreeSponsorRegistration(false);
        return false; // no rego
        
    }

    return (
        <Typography
        sx={{
            marginTop:"20px",
        }}
        >
            {
            sponsorLevel()?
                <Alert
                    severity="info"
                    icon={<FontAwesomeIcon fixedWidth icon={faExclamationCircle} />}
                >
                    There are complimentary registrations left!
                </Alert>
            :
                <Alert
                    severity="info"
                    icon={<FontAwesomeIcon fixedWidth icon={faExclamationCircle} />}
                >
                    All complimentary registrations for this sponsor have been used! You will be charged the full amount to attend the event.

                </Alert>
            }
        </Typography>
    );
}


const RegistrationSteps = [
    {
        label: 'Membership Confirmation (Your name must match your BCT membership application)',
        Inputs: RegistrationStepOne
    },
    {
        
        label: 'Registration Type',
        Inputs: () => {
            const { setFieldValue } = useFormActions();

            const filterTypes = useMemo(() => {
                const output: IFormLookupFilterProps<Dtos.Registration> = {
                    filterFunction: (formState, propertyPath, lookup) => {
                        if (!formState.value?.staffConfirmed) {
                            return {
                                ...lookup,
                                items: lookup?.items?.filter(x => x.id !== 5 && x.id !== 7)
                            }
                        }
                        return {
                            ...lookup
                        }
                    },
                    subscription: { value: true }
                }

                return output;
            }, [])

            const subscription = {
                value: true
            };

            const {
                state: {
                    value: sponsor
                }            } = useScopedField<boolean>('sponsor', subscription);

            const { sponsors } = useSponsors();
        

            return (
                <StepContext.Provider value={1}>
                    <Paper
                        sx={{ p: 4, pt: 0, mt: { xs: 1, md: 3 } }}
                    >
                        <Grid 
                            container
                            columnSpacing={4}
                        >
                            <Grid
                                item
                                xs={12}
                                md={6}
                                mt={4}
                            >
                                
                                {
                                    sponsor?
                                    // this is also a rego field because it simple holds all the strange logic for the steps so you can move past the point as well as
                                    // returning the InputOnlyField......... ? 
                                    <>
                                        <RegistrationField
                                            label="Sponsor"
                                            propertyPath="sponsorId"
                                            component={Select}
                                            nullOption={false}
                                            sx={{margin:"normal"}}
                                            FormControlProps={{
                                                variant: "standard"
                                            }}
                                            options={sponsors?.map((sponsor) => ({ value: sponsor.sponsorName, id: sponsor.id }))}
                                        />
                                        <SponsorLevel />
                                    </>
                                    :
                                        <RegistrationField
                                        label="Registration Type"
                                        propertyPath="registrationType"
                                        component={Select}
                                        nullOption={false}
                                        FormControlProps={{
                                            variant: "standard"
                                        }}
                                        LookupFilterProps={filterTypes}
                                    /> 
                                }
                                     
                                
                            </Grid>

                        </Grid>
                        <Condition
                            condition={studentOrRegistrarOrTrialCoordinatorSelectedCondition}
                            subscription = {{
                                value: true
                            }}
                            mode={ConditionMode.Show}
                        >
                            <Grid 
                                container 
                                columnSpacing={4}
                            >
                                <Grid 
                                    item
                                    xs={12}
                                    md={12}
                                    mt={4}
                                >
                                    <RegistrationField
                                        label="Please enter the name of your supervisor"
                                        propertyPath="supervisorName"
                                        component={Text}
                                        variant="standard"
                                    />
                                </Grid>
                            </Grid> 
                        </Condition>
                    </Paper>
                </StepContext.Provider>
            );
        }
    },
    {
        label: 'Package Selection & Pricing',
        Inputs: RegistrationStepTwo
    },
    {
        label: 'Your Information',
        Inputs: RegistrationStepThree
        },
    { 
        label: 'Payment',
        Inputs: RegistrationStepFour
    }
];

export default RegistrationSteps;